import { v4 } from '@/helpers'
export const VirtualRoomElementContentElementBase = ({
  uuid = v4(),
  content_library_element_id = '',
}) => ({
  uuid,
  content_library_element_id,
})
